export const BUSINESS_LEADS_QUERY_KEY = 'businessLeads'
